const getIntervals = (hours) =>
  [...hours]
    .sort((a, b) => a - b)
    .reduce((acc, hour, idx, arr) => {
      if (idx === 0 || hour !== arr[idx - 1] + 1) {
        acc.push([hour, hour + 1]);
      } else {
        acc[acc.length - 1][1] = hour + 1;
      }
      return acc;
    }, []);

export default getIntervals;
